<template>
  <v-row>
    <v-col cols="12">
      <v-btn color="primary" :loading="loading" :disabled="loading" @click="reload">
        Run Audit
      </v-btn>
    </v-col>

    <v-col cols="12" v-if="Object.keys(webnicCosts).length">
      <h5>WebNic Cost Reference (1 Year)</h5>
      <v-simple-table dense>
        <thead>
          <tr>
            <th>TLD</th>
            <th>Renewal (USD)</th>
            <th>Proxy (USD)</th>
            <th>Total (USD)</th>
            <th>Total (SGD)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cost, tld) in webnicCosts" :key="tld">
            <td>.{{ tld }}</td>
            <td>{{ formatPrice(cost.renewal) }}</td>
            <td>{{ formatPrice(cost.proxy) }}</td>
            <td>{{ formatPrice(cost.total_usd) }}</td>
            <td>{{ formatPrice(cost.total_sgd) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>

    <v-col cols="12" v-if="!loading">
      <h5>Flagged Default Domain Prices ({{ flaggedMemberPrices.length }})</h5>
      <v-simple-table dense v-if="flaggedMemberPrices.length">
        <thead>
          <tr>
            <th>TLD</th>
            <th>Term</th>
            <th>Price</th>
            <th>Year Price</th>
            <th>Cost (SGD)</th>
            <th>Shortfall</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in flaggedMemberPrices" :key="'m' + index">
            <td>.{{ row.tld }}</td>
            <td>{{ row.term_name }}</td>
            <td>{{ formatPrice(row.product_price) }}</td>
            <td>{{ formatPrice(row.year_price) }}</td>
            <td>{{ formatPrice(row.cost_sgd) }}</td>
            <td class="red--text">{{ formatPrice(row.shortfall) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <p v-else class="grey--text">No flagged default domain prices.</p>
    </v-col>

    <v-col cols="12" v-if="!loading">
      <h5>Flagged Partner Prices ({{ flaggedPartnerPrices.length }})</h5>
      <v-simple-table dense v-if="flaggedPartnerPrices.length">
        <thead>
          <tr>
            <th>Partner</th>
            <th>TLD</th>
            <th>Term</th>
            <th>Price</th>
            <th>Year Price</th>
            <th>Cost (SGD)</th>
            <th>Shortfall</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in flaggedPartnerPrices" :key="'p' + index">
            <td>{{ row.email }}</td>
            <td>.{{ row.tld }}</td>
            <td>{{ row.term_name }}</td>
            <td>{{ formatPrice(row.product_price) }}</td>
            <td>{{ formatPrice(row.year_price) }}</td>
            <td>{{ formatPrice(row.cost_sgd) }}</td>
            <td class="red--text">{{ formatPrice(row.shortfall) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <p v-else class="grey--text">No flagged partner prices.</p>
    </v-col>

    <v-col cols="12" v-if="!loading">
      <h5>Flagged Retail Prices ({{ flaggedRetailPrices.length }})</h5>
      <v-simple-table dense v-if="flaggedRetailPrices.length">
        <thead>
          <tr>
            <th>Partner</th>
            <th>TLD</th>
            <th>Term</th>
            <th>Partner Price</th>
            <th>Extra Price</th>
            <th>Year Price</th>
            <th>Cost (SGD)</th>
            <th>Shortfall</th>
            <th>CLDY</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in flaggedRetailPrices" :key="'r' + index">
            <td>{{ row.email }}</td>
            <td>.{{ row.tld }}</td>
            <td>{{ row.term_name }}</td>
            <td>{{ formatPrice(row.partner_price) }}</td>
            <td>{{ formatPrice(row.product_extra_price) }}</td>
            <td>{{ formatPrice(row.year_price) }}</td>
            <td>{{ formatPrice(row.cost_sgd) }}</td>
            <td class="red--text">{{ formatPrice(row.shortfall) }}</td>
            <td>{{ row.is_cldy ? 'Yes' : '' }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <p v-else class="grey--text">No flagged retail prices.</p>
    </v-col>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-row>
</template>

<script>
export default {
  name: 'DomainAuditWebnic',
  data() {
    return {
      loading: false,
      webnicCosts: {},
      flaggedMemberPrices: [],
      flaggedPartnerPrices: [],
      flaggedRetailPrices: [],
    };
  },
  methods: {
    reload() {
      this.loading = true;
      this.$api.get('admin/domain-audit/webnic-pricing').then((response) => {
        this.webnicCosts = response.data.webnic_costs || {};
        this.flaggedMemberPrices = response.data.flagged_member_prices || [];
        this.flaggedPartnerPrices = response.data.flagged_partner_prices || [];
        this.flaggedRetailPrices = response.data.flagged_retail_prices || [];
      }).catch(() => {
        this.webnicCosts = {};
        this.flaggedMemberPrices = [];
        this.flaggedPartnerPrices = [];
        this.flaggedRetailPrices = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    formatPrice(val) {
      if (val === undefined || val === null) return '0.00';
      return parseFloat(val).toFixed(2);
    },
  },
};
</script>
